import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import VueClientRecaptcha from "vue-client-recaptcha";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
});

// Bypass captcha - always set to false (captcha disabled)
const isPreProd = false; // process.env.NODE_ENV.trim() === "preproduction";

createApp(App)
  .use(store)
  .use(router)
  .use(vuetify)
  .use(autoAnimatePlugin)
  .provide("isPreProd", isPreProd)
  .component("VueClientRecaptcha", VueClientRecaptcha)
  .mount("#app");


